import './scss/index.scss';

export { default } from './js/favorite-player-button';
